import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/acc_cost_center'

const updateCostCenter = async (id, object) => {
    try {
        const response = await axios.put(
            route + '/' + id,
            object
        )
        return response.data
    } catch (error) {
        error.response.data
    }
}

export { updateCostCenter }
